import { capitalize } from '@lib';

import { ApiEndpointHandler, createGetEndpoint } from '@sonar-software/sonar-http';
import { Stakeholder, StakeholderType } from '@types';

const getStakeholdersBase = createGetEndpoint<void, Array<Stakeholder>>('/api/v3/core/stakeholders');

export const getStakeholders: ApiEndpointHandler<void, Array<Stakeholder>> = async(_, options) => {
	const result = await getStakeholdersBase(_, options);

	if (result.data) {
		result.data = result.data.map((entry) => ({
			...entry,
			stakeholderType: capitalize(entry.stakeholderType) as StakeholderType
		}));
	}

	return result;
};
